<template>
  <div style="font-size: 0.9rem;margin-left: 20px;margin-right: 30px;">
    <el-row style="border-bottom: 1px solid rgba(41, 155, 255, .2);padding: 30px 0 0 0;">
      <el-button size="mini" class="button" style="margin-bottom: 5px" @touchstart="synchronizationSystemTimeBatch" @click="synchronizationSystemTimeBatch">
        批量同步系统时间
      </el-button>
      <el-collapse>

      </el-collapse>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-table
        :data="tableData"
        :height="tableHeight"
        @selection-change="changeCheckBoxValue"
        style="width: 100%;"
        border>
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          color="#60a7f3"
          width="300"
          label="主机">
          <template slot-scope="scope">
            <div>
              <el-row>
                <el-col :lg="4" :md="4" :sm="4" :xl="4" :xs="12">
                  <div :class="scope.row.status === 1 ? 'green' : 'red'" style="margin-top: 7px!important;"
                       class="status"></div>
                </el-col>
                <el-col :lg="18" :md="18" :sm="18" :xl="18" :xs="24">
                  <div style="float: left;padding-left: 20px;">{{ scope.row.name }}
                    <span v-if="scope.row.hostHand">({{ scope.row.hostHand }})</span>
                    <span v-else>({{ scope.row.host }})</span>
                  </div>
                </el-col>
              </el-row>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          prop="snCode"
          align="center"
          width="280"
          label="序列号">
        </el-table-column>
        <el-table-column
          prop="correlationNumber"
          align="center"
          :formatter="correlationNumber"
          label="关联设备">
        </el-table-column>
        <el-table-column
          prop="note"
          align="center"
          label="备注">
        </el-table-column>
        <el-table-column
          align="center"
          width="370"
          label="操作">
          <template slot-scope="scope">
            <b-button variant="text" style="color: #FDFDFD">
              <b-button v-has-permi="['device:gateway:updateGatewayInfo']" variant="text" style="color: #fdfdfd"
                  @touchstart="openDialog(scope.row)"    @click="openDialog(scope.row)">
                <img src="../../../../assets/images/icon/edit.png" style="margin-bottom: 4px;">
                <span style="margin-left: 4px;">修改</span>
              </b-button>
              <b-button v-has-permi="['device:gateway:synchronizationTime']" variant="text" style="color: #fdfdfd"
                   @touchstart="synchronizationSystemTime(scope.row)"     @click="synchronizationSystemTime(scope.row)">
                <img src="../../../../assets/images/icon/time.png" style="margin-bottom: 4px;">
                <span style="margin-left: 4px;">同步时间</span>
              </b-button>
              <b-button v-has-permi="['device:gateway:clearDevice']" variant="text" style="color: #fdfdfd"
                  @touchstart="clearDeviceBySnCode(scope.row)"      @click="clearDeviceBySnCode(scope.row)" :loading="isEmpty">
                <img src="../../../../assets/images/icon/delete.png" style="margin-bottom: 4px;">
                <span style="margin-left: 4px;">清空设备</span>
              </b-button>
            </b-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <function-dialog-component
      :dialog-title="'修改名称'"
      :closeClick="false"
      :dialogVisible.sync="deviceDialogVisible"
      center
      @dialogClose="(data) => this.deviceDialogVisible = data"
      width="40vw">
      <div slot="content" style="min-height: 20vh;">
        <template>
          <div style="height: 10vh; margin: auto">
            <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
              <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="10"
                      style="line-height: 28px;text-align: right;margin-right: 10px;">主机名称：
              </el-col>
              <el-col :xl="13" :lg="13" :md="13" :sm="13" :xs="13">
                <el-input class="inline-input" size="mini" v-model="form.name" placeholder="请输入主机名称"
                          style="width: 80%"></el-input>
              </el-col>
            </el-col>
            <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
              <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="10"
                      style="line-height: 28px;text-align: right;margin-right: 10px;">空间：
              </el-col>
              <el-col :xl="13" :lg="13" :md="13" :sm="13" :xs="13">
                <el-cascader
                    :options="spaceTree"
                    change-on-select="true"
                    clearable
                    placeholder="请选择空间"
                    size="mini"
                    style="width: 70%"
                    v-model="form.spaceId">
                </el-cascader>
              </el-col>
            </el-col>
          </div>
        </template>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;">
        <el-button size="mini" @touchstart="close"  @click="close">关 闭</el-button>
        <el-button type="primary" @touchstart="submit" @click="submit" size="mini">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import {
  clearDeviceBySnCode,
  gatewayList,
  synchronizationSystemTimeBatch,
  synchronizationTime,
  updateGatewayInfo
} from '@/network/device-gateway';
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import {getSpaceTreeData, getTree} from "@/network/space-info";

export default {
  name: "Host",
  components: {FunctionDialogComponent},
  data() {
    return {
      isEmpty: false,
      // 选中的snCode
      snCodeList: [],
      title: "编辑主机名称",
      tableData: [],
      form: {
        name: '',
        snCode: '',
        spaceId: [],
      },
      deviceDialogVisible: false,
      spaceTree: [],
    }
  },
  created() {
    this.getData();
    this.getSpaceTreeData();

  },
  computed: {
    tableHeight() {
      return window.innerHeight * 0.55
    }
  },
  methods: {
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.spaceTree = getTree(res.data);
          console.log(this.spaceTree, 'spaceTree');
        }
      });
    },
    getSpaceName(spaceId) {
      // 递归查找空间名称
      const findSpaceName = (tree, id) => {
          for (let node of tree) {
              // 如果找到匹配的ID，返回该节点的标题
              if (node.value === id) {
                  return node.label
              }
              // 如果有子节点，递归查找
              if (node.children && node.children.length) {
                  const found = findSpaceName(node.children, id);
                  if (found) return found;
              }
          }
          return null;
      };
      const result = findSpaceName(this.spaceTree, spaceId);
      return result || '未知空间';
    },
    correlationNumber(data) {
      return data.correlationNumber + "(个)";
    },
    changeCheckBoxValue: function (val) {
      this.snCodeList = [];
      for (let i = 0; i < val.length; i++) {
        let id = val[i].snCode;
        this.snCodeList.push(id);
      }
      console.log(this.snCodeList);
    },
    //打开弹窗 编辑主机名称
    openDialog(val) {
      this.form.name = val.name;
      this.form.snCode = val.snCode;
      this.form.spaceId = val.spaceId;
      this.deviceDialogVisible = true;
    },
    close() {
      this.form.snCode = '';
      this.form.name = '';
      this.form.spaceId = [];
      this.deviceDialogVisible = false;
    },
    submit() {
      if (this.form.name.length <= 0) {
        this.$message.error('请输入主机名');
      } else if (this.form.name.length > 20) {
        this.$message.error('主机名过长');
      } else {
        // 创建提交数据对象
        const submitData = {
          name: this.form.name,
          snCode: this.form.snCode
        };
        
        // 判断是否选择了空间
        if (this.form.spaceId && this.form.spaceId.length > 0) {
          // 获取最后一级的空间ID
          const spaceId = this.form.spaceId[this.form.spaceId.length - 1];
          console.log(spaceId, 'spaceId');
          submitData.spaceId = spaceId;
          
          // 获取空间名称
          const spaceName = this.getSpaceName(spaceId);
          submitData.spaceName = spaceName;
        }
        
        updateGatewayInfo(submitData).then(res => {
          this.deviceDialogVisible = false;
          if (res.code === 0) {
            this.$message.success('操作成功');
          } else {
            this.$message.error('操作失败');
          }
          this.getData();
        });
      }
    },
    clearDeviceBySnCode(val) {
      this.$confirm('是否清空：' + '[' + val.name + ']' + "的设备", {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          this.isEmpty = true;
          if (action === 'confirm') {
            clearDeviceBySnCode(val.snCode).then(res => {
              if (res.code === 0) {
                this.$message.success('清空成功');
              } else {
                this.$message.error('清空失败');
              }
              this.isEmpty = false;
              this.getData();
            });
          }
        }
      })
    },
    synchronizationSystemTime(val) {
      console.log(val);
      this.$confirm('是否确认同步：' + '[' + val.name + ']' + val.host + "的时间", {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            synchronizationTime(val.snCode).then(res => {
              if (res.code === 0) {
                this.$message.success('同步成功');
              } else {
                this.$message.error(res.message);
              }
              this.getData();
            });
          }
        }
      })
    },
    synchronizationSystemTimeBatch() {
      if (this.snCodeList.length <= 0) {
        this.$message.error("请选择需要同步的主机");
        return;
      }
      this.$confirm('是否确认同步：' + this.snCodeList.length + "个主机的时间", {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            synchronizationSystemTimeBatch(this.snCodeList).then(res => {
              if (res.code === 0) {
                this.$message.success('同步成功');
              } else {
                this.$message.error(res.message);
              }
              this.getData();
            });
          }
        }
      })
    },
    // 获取主机列表
    getData() {
      gatewayList().then(res => {
        if (res.code === 0) {
          // 列表数据
          let bln = res.data == null;
          this.tableData = bln ? null : res.data;
        }
      })
    }
  }
}
</script>

<style scoped>
.status {
  float: right;
  margin: 20px 0 0 24px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 1;
}

.green {
  background: #15DEB5;
}

.red {
  background: rgba(232, 86, 86, 1);
}
</style>
